import { IconButton, InputBase, Paper } from "@mui/material"
import React from "react"
// import { isEmpty } from "lodash";
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import "./index.css"

const Search = ({
  inputRef,
  searchValue,
  handleSearchChange,
  onClose,
  addStyle,
  rest,
  showSearchIcon = true,
  placeholder = "Search",
}) => {
  return (
    <Paper className="addPackage-paper1" style={{ ...addStyle }}>
      <InputBase
        endAdornment={
          <IconButton
            type="button"
            className="addPackage-inputButton1"
            aria-label="search"
          >
            {!searchValue ? (
              <SearchIcon onClick={onClose} />
            ) : (
              // <img
              //   src={Vector}
              //   height={20}
              //   width={23}
              //   alt="search"
              //   color="#5C5B57"
              // />
              <CloseIcon onClick={onClose} />
            )}
          </IconButton>
        }
        className="addPackage-inputBase1"
        placeholder={placeholder}
        value={searchValue}
        onChange={handleSearchChange}
        sx={{
          ml: 2,
          flex: 1,
          "& input::placeholder": {
            color: "#e1e1e1e",
            fontSize: "14px",
            fontWeight: 400,
          },
        }}
        inputProps={{ "aria-label": "search google maps" }}
        size="small"
        inputRef={inputRef}
        {...rest}
      />
    </Paper>
  )
}

export default Search
